import { t } from "@lingui/core/macro"
import { useAppDispatch } from "../../../store/hooks"
import { setCurrentSearchUsername } from "../../../store/messagingSlice"
import { addPageAction } from "../../../utils/newrelic"
import { ChevronLeftBlue } from "../../common/atoms/Icons/Chat"
import { IconButton } from "../common/IconButton/IconButton"
import { SearchInput } from "../common/SearchInput/SearchInput"
import { useMessagingView } from "../hooks"
import { classNames } from "../utils"
import styles from "./ThreadSearch.module.scss"
import { GeneralViewModel } from "./viewModels/GeneralViewModel"
import { UnifiedDesktopViewModel } from "./viewModels/UnifiedDesktopViewModel"
import type { ThreadSearchViewModelPros } from "./viewModels/ThreadSearchTypes"

type Props = {
    className?: string
    inputProps?: React.InputHTMLAttributes<HTMLInputElement>
    onTyping?: (query: string) => void
    focusCallback?: (focused: boolean) => void
}

const TYPING_THROTTLE__MS = 500

export function ThreadSearch({
    className,
    inputProps,
    onTyping,
    focusCallback,
}: Props) {
    const dispatch = useAppDispatch()
    const messagingView = useMessagingView()

    const viewModelprops: ThreadSearchViewModelPros = {
        dispatch,
        typingThrottle: TYPING_THROTTLE__MS,
        onTyping,
        focusCallback,
    }
    const { text, setText, focused, handleFocus } =
        messagingView.isDesktopUnified
            ? UnifiedDesktopViewModel(viewModelprops)
            : GeneralViewModel(viewModelprops)

    return (
        <div className={classNames(styles.threadSearchInput, className)}>
            {messagingView.isMobile && (
                <IconButton
                    icon={<ChevronLeftBlue height={16} width={10} />}
                    iconAlt="Back"
                    onClick={() => {
                        handleFocus(false)
                        addPageAction("DmConversationSearch", {
                            actionType: "exit",
                        })
                    }}
                    className={classNames(styles.threadSearchBack, {
                        [styles.focused]: focused,
                    })}
                />
            )}
            <SearchInput
                className="thread-search-component"
                inputProps={{
                    ...inputProps,
                    value: text,
                    onClick: () => handleFocus(true),
                    onChange: (e) => {
                        setText(e.target.value)
                    },
                    placeholder: t`Search usernames`,
                }}
                onClear={
                    text.trim()
                        ? () => {
                              setText("")
                              addPageAction("DmConversationSearch", {
                                  actionType: "cleared",
                              })
                              dispatch(setCurrentSearchUsername(null))
                          }
                        : undefined
                }
            />
        </div>
    )
}
